import type { ReactNode } from 'react';
import { StepBasics } from './StepBasics';
import { StepCollection } from './StepCollection';
import { StepItemType } from './StepItemType';
import { StepMaterials } from './StepMaterials';
import { StepPricingInventory } from './StepPricingInventory';
import { StepProductionMethods } from './StepProductionMethods';
import { StepVariants } from './StepVariants';
import type { ProductFormErrors, ProductFormState } from './types';

interface SinglePageLayoutProps {
  state: ProductFormState;
  updateState: (updater: ProductFormState | ((prev: ProductFormState) => ProductFormState)) => void;
  errors: ProductFormErrors;
  isEditMode?: boolean;
}

function Section({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <section className="pb-8 border-b border-gray-200 dark:border-charcoal-700 last:border-0">
      <h3 className="font-display text-lg font-semibold text-gray-900 dark:text-warm-cream mb-4">
        {title}
      </h3>
      {children}
    </section>
  );
}

export function SinglePageLayout({ state, updateState, errors, isEditMode = false }: SinglePageLayoutProps) {
  return (
    <div className="space-y-8">
      <Section title="Name & Basics">
        <StepBasics state={state} updateState={updateState} nameError={errors.name} />
      </Section>
      <Section title="Product Type">
        <StepItemType state={state} updateState={updateState} error={errors.itemTypeId} />
      </Section>
      <Section title="Collection & Design">
        <StepCollection state={state} updateState={updateState} />
      </Section>
      <Section title="Production Method">
        <StepProductionMethods state={state} updateState={updateState} />
      </Section>
      <Section title="Materials & Design">
        <StepMaterials state={state} updateState={updateState} isEditMode={isEditMode} />
      </Section>
      <Section title="Variants">
        <StepVariants state={state} updateState={updateState} error={errors.variants} />
      </Section>
      <Section title="Pricing & Inventory">
        <StepPricingInventory
          state={state}
          updateState={updateState}
          priceError={errors.basePrice}
        />
      </Section>
    </div>
  );
}
